<template>
  <pl-select
    name="secondary-navigation"
    :selected="active"
    @change="onChange"
    class="md:hidden w-full lg:w-5/6"
    select-class="bg-white"
  >
    <option v-bind:key="option.id" v-for="option of menuItems" :value="option.id"> {{ option.title }}</option>
  </pl-select>
</template>

<script>
export default {
  name: 'mobileMenuControls',
  props: {
    menuItems: Array,
    active: String
  },
  methods: {
    onChange (id) {
      this.$emit('change', id)
    }
  }
}
</script>
